import React from "react";
import { getDistressRateColor, DISTRESS_RATE_COLORS } from "src/utils/listings";

const DistressRate = ({ rate }) => {
  const parsedRate = parseInt(rate);
  
  return (
    <>
      <div className="flex lg:gap-4 gap-2 items-center">
        <p className="font-semibold text-[12px] lg:leading-4 md:leading-3 text-gray-secondary">
          Level of Distress
        </p>
        <div className="flex gap-1">
          <div
            className={`h-2 md:w-14 w-10 rounded-lg`}
            style={{ backgroundColor: parsedRate > 0 ? DISTRESS_RATE_COLORS.LEVEL_1 : DISTRESS_RATE_COLORS.DEFAULT }}
          ></div>
          <div
            className={`h-2 md:w-14 w-10 rounded-lg`}
            style={{ backgroundColor: parsedRate > 1 ? DISTRESS_RATE_COLORS.LEVEL_2 : DISTRESS_RATE_COLORS.DEFAULT }}
          ></div>
          <div
            className={`h-2 md:w-14 w-10 rounded-lg`}
            style={{ backgroundColor: parsedRate > 2 ? DISTRESS_RATE_COLORS.LEVEL_3 : DISTRESS_RATE_COLORS.DEFAULT }}
          ></div>
          <div
            className={`h-2 md:w-14 w-10 rounded-lg`}
            style={{ backgroundColor: parsedRate > 3 ? DISTRESS_RATE_COLORS.LEVEL_4 : DISTRESS_RATE_COLORS.DEFAULT }}
          ></div>
        </div>
      </div>
    </>
  );
};

export default DistressRate;
